import { render, staticRenderFns } from "./HexagonTriangle.vue?vue&type=template&id=08769214&"
import script from "./HexagonTriangle.vue?vue&type=script&lang=js&"
export * from "./HexagonTriangle.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports